export enum PILL_TYPE {
  ORGANIZATION = 'Organization',
  BRAND = 'Brand',
  CATEGORY = 'Category',
  SUBCATEGORY = 'Subcategory',
  PRODUCT = 'Product',
  SEGMENT = 'Segment',
  BUSINESS_UNIT = 'Business Unit',
  AD_ENTITY = 'Entity',
  AD_PORTFOLIO = 'Portfolio',
  AD_CAMPAIGN = 'Campaign',
  AD_GROUP = 'Ad Group',
  AD_TARGET = 'Ad Target',
  TREND = 'Microtrend'
}
